export enum WallItemPlacement {
  EvenlyDistributed = 'evenly-distributed',
  FixedAtEnd = 'fixed-at-end',
  FixedAtStart = 'fixed-at-start',
  Percentage = 'percentage',
}
